import {createActionGroup} from '@ngrx/store';
import {ACTIVE_ROUTER_TAB_FEATURE_KEY} from '@aviary/store/active-router-tab/active-router-tab.types';

// For each app to call in an adapter file, using its own RouteName type.
export function createActiveRouterTabActions<RouteNameType extends string = string>() {
  return createActionGroup({
    source: ACTIVE_ROUTER_TAB_FEATURE_KEY,
    events: {
      'Save': (parentRouteName: RouteNameType, routeName: RouteNameType) => ({parentRouteName, routeName}),
      'Clear': (parentRouteName: RouteNameType) => ({parentRouteName})
    }
  });
}

// For Aviary use only.
export const ActiveRouterTabActions = createActiveRouterTabActions<string>();
